var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page home"},[(_vm.user)?_c('div',{staticClass:"home__welcome"},[_vm._v(_vm._s(_vm.$t('home.welcome'))+" "+_vm._s(_vm.user.naam)+"!")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }